import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { DocumentTemplateListData, DocumentTemplateListDataService } from '../document-template-list-data.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { getSideListOptionsBottomFn } from '@fi-shared/fi-items-list/side-list-options';
import { AppTextService } from '@fi-shared/app-text';
import { FiLocalSearchParameterModel } from '@fi-shared/fi-local-search2/fi-local-search-parameter.model';
import { DocumentTemplateService } from '../document-template.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AccessRightType, ApplicationSettingsType, SideListOptionType } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { TemplateModel } from '@fi-app/template/template.model';

@Component({
    selector: 'fi-document-template-list-view',
    templateUrl: './document-template-list-view.component.html',
    styleUrls: ['./document-template-list-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-template-list-view' },
    standalone: false,
})
export class DocumentTemplateListViewComponent
    extends ItemsListContainerBase<DocumentTemplateListData>
    implements OnInit
{
    SideListOptionsTop: ISideListOptionsItem[] = [];
    SideListOptionsBottom: ISideListOptionsItem[] = [];
    FiStateNames = FiStateNames;

    constructor(
        private templatesService: DocumentTemplateService,
        private injector: Injector,
        private stateAccessCheckService: StateAccessCheckService,
        private templateListDataService: DocumentTemplateListDataService,
        private appTextService: AppTextService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () => {
                return this.templateListDataService.getInstance();
            },
            { showDelete: false },
        );

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
        this.initSideList();
    }

    private initSideList(): void {
        this.SideListOptionsTop = [
            { value: SideListOptionType.SharedWithMe, text: this.appTextService.get('common.shared_with_me') },
            { value: SideListOptionType.CreatedBy, text: this.appTextService.get('common.created_by_me') },
            { value: SideListOptionType.Favorite, text: this.appTextService.get('common.my_favorites') },
            { value: SideListOptionType.Deleted, text: this.appTextService.get('common.trash') },
        ];
        super.checkApplySuperAdminRight(
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.DocumentGlobal,
                AccessRightType.SuperAdmin,
            ),
            this.SideListOptionsTop,
            this.appTextService.get('all_templates'),
        );

        this.SideListOptionsBottom = getSideListOptionsBottomFn(this.appTextService);
    }

    private GetLocalSearchParameter() {
        const result = new FiLocalSearchParameterModel();

        Object.assign(result, this.ListData.getOffsetParams());

        result.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        result.FilterType = this.ListData.FilterType;

        this.ListData.mergeLocalSearchV2Parameter(result);
        return result;
    }

    protected LoadItems(): Promise<void> {
        const fetchingAllData = this.ListData.fetchingAllData;
        const parameter = this.GetLocalSearchParameter();
        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: fetchingAllData,
            FetchLightWeightObjects: fetchingAllData,
        };
        return this.templatesService.getTemplatesListData(parameter).then((response) => {
            this.ListData.appendData(response.Items.map((item) => new TemplateModel(item, this.injector)));

            if (fetchingAllData) {
                this.ListData.SetTotalItemsCount(response.TotalCount);

                const lightWeightObjectCollection = response.LightWeightObjectsForLocalSearch;
                if (lightWeightObjectCollection) {
                    this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
                }
            }
        });
    }
}
